import { gql } from '@apollo/client';

export const USER_UPDATE = gql`
  mutation UserUpdate(
    $id: ID!
    $name: String!
    $email: String!
    $role: String!
    $isVerified: Boolean
  ) {
    userUpdate(id: $id, name: $name, email: $email, role: $role, isVerified: $isVerified)
  }
`;

export const USER_DELETE = gql`
  mutation UserUpdate($id: ID!) {
    userDelete(id: $id)
  }
`;
